import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=c320576a&scoped=true"
import script from "./QuoteCard.vue?vue&type=script&lang=js"
export * from "./QuoteCard.vue?vue&type=script&lang=js"
import style0 from "./QuoteCard.vue?vue&type=style&index=0&id=c320576a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c320576a",
  null
  
)

export default component.exports